/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class UserIcon extends BaseIcon {
    getChildren = () => [
        <g fill={this.getColor()}>
            <circle cx="8" cy="4" r="4"/>
            <path d="M0,13.37c0-2.61,5.33-4,8-4s8,1.43,8,4V16H0Z"/>
        </g>
    ]
    getViewBox = () => '0 0 16 16'
}
